import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoIdDefaultLabel = ({
  objectId,
  parenthesize = false
}) => {
  if (parenthesize) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: ["(", /*#__PURE__*/_jsx(FormattedMessage, {
        message: "flow-doctor-lib.global.id",
        options: {
          objectId: objectId.toString()
        }
      }), ")"]
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "flow-doctor-lib.global.id",
      options: {
        objectId: objectId.toString()
      }
    })
  });
};
export default NoIdDefaultLabel;